import { render, staticRenderFns } from "./BaseIcon.vue?vue&type=template&id=f2fe56f4&scoped=true&"
import script from "./BaseIcon.vue?vue&type=script&lang=ts&"
export * from "./BaseIcon.vue?vue&type=script&lang=ts&"
import style0 from "./BaseIcon.vue?vue&type=style&index=0&id=f2fe56f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2fe56f4",
  null
  
)

export default component.exports